<div
  class="flex max-w-screen-sm justify-between py-3"
  [style.color]="textColor | contentBuilderColor"
>
  @if (!isProductExists) {
    <div class="mb-1.5 mr-2 flex items-center">
      <div class="icon icon-warning-square text-error-800"></div>
      <span
        class="ml-2 inline-block font-base text-base font-bold leading-6 text-error-700 lg:text-md"
      >
        {{ 'errors.product-not-found-item' | translate }}
      </span>
      <app-button-atom
        size="XS"
        [label]="'Retirer'"
        color="primary"
        (click)="removeItem.emit(id)"
        icon="icon-cross"
        type="link"
      ></app-button-atom>
    </div>
  }
  @if (isProductExists) {
    <div
      class="mr-2"
      (click)="isOwner && isProductExists ? updateItem.emit(id) : $event.preventDefault()"
    >
      <div class="flex items-center">
        <app-quantity-atom
          [quantity]="quantity"
          [textColor]="quantityBadgeTextColor"
          [backgroundColor]="quantityBadgeBackgroundColor"
        ></app-quantity-atom>
        <span
          class="inline-block font-base text-base leading-6 ml-1.5"
          [style.color]="productNameColor | contentBuilderColor"
        >
          {{ name }}
        </span>
        @if (isOwner) {
          <span class="ml-2"><i class="icon icon-pencil text-sm text-neutral-600"></i></span>
        }
      </div>
      @if (childItems && childItems.length > 0) {
        <div
          class="flex flex-wrap mt-1.5"
          [style.color]="productDetailsColor | contentBuilderColor"
        >
          @for (item of childItems; track item; let last = $last) {
            <span class="text-sm leading-4.5 lg:text-base"
              >{{ formatCartOptionLabel(item) + (!last ? ',&nbsp;' : '') }}
            </span>
          }
        </div>
      }
      @if (groupAdditionsItems && groupAdditionsItems.length > 0) {
        <div
          class="flex flex-wrap mt-1.5"
          [style.color]="productDetailsColor | contentBuilderColor"
        >
          @for (item of groupAdditionsItems; track item; let last = $last) {
            <span class="text-sm leading-4.5 lg:text-base"
              >{{ formatCartOptionLabel(item) + (!last ? ',&nbsp;' : '') }}

              @for (
                additionOfItem of item.additions?.items;
                track additionOfItem;
                let lastAdditionOfItems = $last
              ) {
                <span
                  >{{
                    formatCartOptionLabel(additionOfItem) + (!lastAdditionOfItems ? ',&nbsp;' : '')
                  }}
                </span>
              }
            </span>
          }
        </div>
      }
      @if (groupCompoundItems && groupCompoundItems.length > 0) {
        <div
          class="flex flex-wrap mt-1.5"
          [style.color]="productDetailsColor | contentBuilderColor"
        >
          @for (item of groupCompoundItems; track item; let last = $last) {
            <li>
              @for (el of item.products; track el) {
                <span class="text-sm leading-4.5 lg:text-base"
                  >{{ formatCartOptionLabel(el) + (!last ? ',&nbsp;' : '') }}
                  @if (!last) {
                    <span>
                      @for (
                        additionsOfEl of el.additions.items;
                        track additionsOfEl;
                        let lastAdditionsOfEl = $last
                      ) {
                        <span
                          >{{
                            formatCartOptionLabel(additionsOfEl) +
                              (!lastAdditionsOfEl ? ',&nbsp;' : '')
                          }}
                        </span>
                      }
                    </span>
                  }
                </span>
              }
            </li>
          }
        </div>
      }
    </div>
  }
  <div
    class="flex w-1/4 flex-shrink-0 flex-row justify-end text-base"
    [style.color]="textColor | contentBuilderColor"
  >
    @if (isBasketOrder) {
      <app-price-atom
        [bold]="false"
        [amount]="price"
        [format]="formatPrice"
      ></app-price-atom>
    }
    @if (!isBasketOrder) {
      <app-price-atom
        [bold]="false"
        [amount]="price * quantity"
        [format]="formatPrice"
      ></app-price-atom>
    }
    @if (displayRemoveIcon) {
      <div class="flex-grow-0 pl-4">
        <app-icon-button
          (onClick)="removeItem.emit(id)"
          icon="icon-cross text-base"
          color="error"
          [intensity]="300"
        ></app-icon-button>
      </div>
    }
  </div>
</div>
